export const DEFAULT_REDIRECT_URL =
  "https://www.chargepoint.com/partners/training-certification";
